import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorRulesGridDataProviderFactory } from '../factory/IntegrityMonitorRulesGridDataProviderFactory';
import {
  Column,
  ColumnKeys,
  PartialIntegrityMonitorRulesGridWebComponentSchema,
  PREDEFINED_FILTERS_KEYS,
} from '../types';
import { ViewType } from '../../integrityMonitorRulesSmartViews/types';
import { IntegrityMonitorRulesGridGzDataProvider } from '../dataProvider/IntegrityMonitorRulesGridGzDataProvider';
import { ViewConfiguration } from '../../../../grid/gridView/types';
import { ColumnDetails } from '../../../../grid/types/common';

export class IntegrityMonitorRulesGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorRulesGridDataProviderFactory;
  public dataProvider: IntegrityMonitorRulesGridGzDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorRulesGridDataProviderFactory(),
    });
  }

  async getDataForView(viewType: ViewType): Promise<PartialIntegrityMonitorRulesGridWebComponentSchema> {
    const predefinedFiltersKeys: Array<ColumnKeys> = PREDEFINED_FILTERS_KEYS;
    let defaultViewProps: ViewConfiguration<Column, ColumnKeys, ViewType>;
    let allColumnDetails: Array<ColumnDetails<Column, ColumnKeys>>;

    switch (viewType) {
      case ViewType.DEFAULT_OS_RULES:
        defaultViewProps = this.dataProvider.getDefaultOsRulesDefaultViewProps();
        allColumnDetails = this.dataProvider.getRulesViewColumnDetails(true);
        break;
      case ViewType.DEFAULT_APPLICATION_RULES:
        defaultViewProps = this.dataProvider.getDefaultApplicationRulesDefaultViewProps();
        allColumnDetails = this.dataProvider.getRulesViewColumnDetails(true);
        break;
      case ViewType.CUSTOM_RULES:
        defaultViewProps = this.dataProvider.getCustomRulesDefaultViewProps();
        allColumnDetails = this.dataProvider.getRulesViewColumnDetails(true);
        break;
      case ViewType.RULE_SET:
        defaultViewProps = this.dataProvider.getRuleSetDefaultViewProps();
        allColumnDetails = this.dataProvider.getRulesViewColumnDetails(false, true);
        break;
      case ViewType.ALL_RULES:
      default:
        defaultViewProps = this.dataProvider.getAllRulesDefaultViewProps();
        allColumnDetails = this.dataProvider.getRulesViewColumnDetails();
    }

    return {
      allColumnDetails,
      defaultViewProps,
      predefinedFiltersKeys,
    };
  }

  async getRulesCountForRuleSet(ruleSetId: string): Promise<number> {
    return this.dataProvider.getRulesCountForRuleSet(ruleSetId);
  }

  async unassignRulesFromRuleSet(ruleIds: Array<string>, ruleSetId: string): Promise<Object | null> {
    return this.dataProvider.unassignRulesFromRuleSet(ruleIds, ruleSetId);
  }
}
